module.exports = __webpack_public_path__ + "static/media/MD.c003e08e.png";